import styled, { css } from 'styled-components';

export const Pill = styled.span(
  ({ theme }) => css`
    ${theme.typography.heading.desktop.xxxs};
    display: inline-flex;
    align-items: center;
    gap: ${theme.sz.s1};
    padding: ${theme.sz.s1} ${theme.sz.s2};
    border-radius: ${theme.bo.round};
    background-color: ${theme.co.information98};
    color: ${theme.co.information40};
    font-size: ${theme.sz.s3};
    white-space: nowrap;

    svg {
      width: ${theme.sz.s3};
      height: ${theme.sz.s3};
    }
  `,
);
